import "./activity.scss";

import { Outlet } from "react-router-dom";

import { FilterRatePerPaxProvider } from "../rate-per-pax/filter-rate-per-pax/filter-rate-per-pax.context";
import { FilterActivityProvider } from "./filter-activity/filter-activity.context";

export function Activity() {
  return (
    <div id="ShellActivity" className="activity">
      <FilterActivityProvider>
        <FilterRatePerPaxProvider>
          <Outlet />
        </FilterRatePerPaxProvider>
      </FilterActivityProvider>
    </div>
  );
}

export default Activity;
